import { useQuery, UseQueryResult } from "react-query";
import api from "../../service/api";

export type RegisterSellerAnalytic = {
  brands: {
    cod: number;
    name: string;
    count: number;
  }[];
  status: {
    cod: number;
    name: string;
    color: string;
    count: number;
  }[];
  total: number;
};

export type RegisterSellerFiltersAnalytic = {
  brandsCodes?: string[];
  statusNames?: string[];
  isStatusPending?: string;
};

interface RegisterSellerApiResponse {
  data: RegisterSellerAnalytic;
}

export async function getRegisterSellersAnalytic(
  filter?: RegisterSellerFiltersAnalytic
): Promise<RegisterSellerAnalytic> {
  const { data } = await api.get<RegisterSellerApiResponse>(
    "/register-seller/analytic",
    {
      params: {
        ...filter,
        brandsCodes: filter?.brandsCodes?.join(","),
        statusNames: filter?.statusNames?.join(","),
      },
    }
  );

  return data.data;
}

export function useRegisterSellersAnalytic(
  filter?: RegisterSellerFiltersAnalytic
): UseQueryResult<RegisterSellerAnalytic> {
  return useQuery(
    ["register-sellers-analytic", filter],
    () => getRegisterSellersAnalytic(filter),
    {
      staleTime: 1000 * 60 * 10, // 10 Minutos
    }
  );
}
